import { styled } from '@mui/material';
import { Grid } from '@mui/system';

export const HoverSection = styled(Grid)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '10px',
  height: '100%',
  zIndex: 100,
  '&:hover': {
    cursor: 'e-resize',
  },
  '&.expanded:hover': {
    cursor: 'w-resize',
  },
  '& > .left-border': {
    height: 'inherit',
    backgroundColor: '#8A9097',
    position: 'absolute',
    '&.hovered': {
      width: '2px',
    },
  },
}));